import API from '../index';
import { CreditCard } from '../../types/payment';

const getSavedCard = async (): Promise<CreditCard> => {
  const data: CreditCard = await API.get('/customer/method/stripe');
  return data;
};

export default getSavedCard;
